import { render } from "./RatingItem.vue?vue&type=template&id=2d8d1260&scoped=true"
import script from "./RatingItem.vue?vue&type=script&lang=js"
export * from "./RatingItem.vue?vue&type=script&lang=js"

import "./RatingItem.vue?vue&type=style&index=0&id=2d8d1260&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8d1260"]])

export default __exports__